import { SPECIAL_USERS, ROLES } from "../../../utils/constants";
import { UserFromAPI } from "../../../types/auth.types";

const ALLOWED_USERS = [SPECIAL_USERS.shilan, SPECIAL_USERS.maria_antunes];
const ALLOWED_ROLES = [ROLES.admin, ROLES.tech_admin];
const PSYCHOLOGY_ROLES = [ROLES.theurapist, ROLES.nfb_and_theurapist];

const isUserAdminRelatedRole = (userId?: string, roleId?: string) => {
	const isAllowedUser = !!userId && ALLOWED_USERS.includes(userId);
	const isAllowedRole = !!roleId && ALLOWED_ROLES.includes(roleId);
	return isAllowedUser || isAllowedRole;
};

const isUserNfbRole = (roleId?: string) => {
	const isNfbRole = !!roleId && roleId === ROLES.nfb_techncians;
	return isNfbRole;
};

const isUserClientOwnerRole = (roleId?: string) => {
	const isClientOwnerRole = !!roleId && roleId === ROLES.client_owner;
	return isClientOwnerRole;
};

const isUserPsyRole = (roleId?: string) => {
	const isPsychologyRole = !!roleId && PSYCHOLOGY_ROLES.includes(roleId);
	return isPsychologyRole;
};

const isUserTreatmentPsy = (userId?: string, roleId?: string, treatmentTherapistsUserIds?: Array<string>) => {
	const isTreatmentTherapist = !!userId && !!treatmentTherapistsUserIds && treatmentTherapistsUserIds.includes(userId);
	return isUserPsyRole(roleId) && isTreatmentTherapist;
};

const isUserTreatmentPrescriber = (userId?: string, treatmentPrescriberUserId?: string) => {
	const isPrescriber = !!userId && !!treatmentPrescriberUserId && userId === treatmentPrescriberUserId;
	return isPrescriber;
};

const isUserTreatmentClientOwner = (userId?: string, treatmentClientOwnerUserId?: string) => {
	const isOwner = !!userId && !!treatmentClientOwnerUserId && userId === treatmentClientOwnerUserId;
	return isOwner;
};

const isUserReportSessionTechnician = (user?: UserFromAPI, reportSessionTechnicianIds?: Array<number>) => {
	if (!reportSessionTechnicianIds || reportSessionTechnicianIds.length === 0) return false;
	const userTechnicianIds = (user?.technician_id ?? []).map((technician) => technician?.id).filter(Boolean);
	const isReportSessionTechnician = userTechnicianIds.some((technicianId) => reportSessionTechnicianIds.includes(technicianId));
	return isReportSessionTechnician;
};

const isUserNFBDirector = (user?: string) => {
	return user && user === SPECIAL_USERS.filipa_nfb_director;
};

export const canSeePsyInstrumentsResponses = (
	user?: UserFromAPI,
	treatmentPrescriberUserId?: string,
	treatmentClientOwnerUserId?: string,
	treatmentTherapistsUserIds?: Array<string>,
	reportSessionTechnicianIds?: Array<number>
) => {
	const userId = user?.id;
	const roleId = user?.role?.id;
	if (isUserAdminRelatedRole(userId, roleId)) return true;
	if (isUserNfbRole(roleId)) return true;
	if (isUserClientOwnerRole(roleId)) return true;
	if (isUserTreatmentPsy(userId, roleId, treatmentTherapistsUserIds)) return true;
	if (isUserTreatmentPrescriber(userId, treatmentPrescriberUserId)) return true;
	if (isUserTreatmentClientOwner(userId, treatmentClientOwnerUserId)) return true;
	if (isUserReportSessionTechnician(user, reportSessionTechnicianIds)) return true;
	if (isUserNFBDirector(userId)) return true;
	return false;
};

export const canSeePsyNotes = (userId?: string, roleId?: string, treatmentTherapistsUserIds?: Array<string>) => {
	if (isUserAdminRelatedRole(userId, roleId)) return true;
	if (isUserTreatmentPsy(userId, roleId, treatmentTherapistsUserIds)) return true;
	return false;
};
